<template>
    <cell ref="cell" class="pp-cell-slide" 
        v-bind="$attrs"
        :with-more="currentWithMore"
        @touchstart.native.stop="dragStart"
        @touchmove.native.stop="drag"
        @touchend.native.stop="dragEnd">
        <template v-if="$slots.prefix" slot="prefix">
            <slot name="prefix"></slot>
        </template>
        <template v-if="$slots.suffix" slot="suffix">
            <slot name="suffix"></slot>
        </template>
        <template v-if="$slots.default">
            <slot></slot>
        </template>
    </cell>
</template>

<script>
/**
 * 右滑移动单元格(后期开放左右侧滑动)
 * @desc 依赖<pp-cell>，将接受并传递pp-cell的参数
 * @param {Boolean} withMore 是否显示右侧图标
 */
import cell from '../../cell/src/cell.vue'

export default {
    name: 'pp-cell-slide',
    inheritAttrs: false,
    inject: {
        CellGroup: {
            default: '',
        },
    },
    components: {
        cell,
    },
    props: {
        withMore: Boolean,
    },
    data: function() {
        return {
            start: {
                x: 0, y: 0
            },
            move: 0,

            isEnter: false,
            isVerticalScroll: false,

            elSuffix: null,
            elContent: null,
            elSuffixWidth: 0,
        };
    },
    computed: {
        currentWithMore: function() {
            return this.withMore || this.CellGroup.withMore;
        },
    },
    watch: {
        move: function(n, o) {
            if(!this.isEnter) {
                let offset = this.elSuffixWidth + n;
                this.sliderMove(offset)
            }
            else if(this.isEnter && n > 0) {
                this.sliderLeave()
            }
        },
        '$slots.suffix': {
            deep: true,
            handler: function() {
                this.layout()
            },
        },
    },
    mounted: function() {
        this.layout()
    },
    methods: {
        dragStart: function({ touches }) {
            this.start = {
                x: touches[0].clientX,
                y: touches[0].clientY,
            }

        },
        drag: function({ touches }) { 
            let sub = touches[0].clientX - this.start.x;
            let vertical = touches[0].clientY - this.start.y;
                
            this.isVerticalScroll = Math.abs(vertical) > Math.abs(sub)

            if(this.isVerticalScroll) return; //判定为上下滑动

            if(sub < 0 && sub <= -this.elSuffixWidth) { //左滑超出
                this.move = -this.elSuffixWidth
            }
            else if(sub > 0 && sub >= this.elSuffixWidth){ //右滑超出
                this.move = this.elSuffixWidth
            }
            else {
                this.move = sub
            }

        },
        dragEnd: function() {
            if(this.move <= -30) {
                this.sliderEnter()
            }
            else {
                this.sliderLeave()
            }
        },

        /**
         * get css translate3d string
         * @param {number} offset translateX
         * @return {string} whole string of translate3d style
         */
        translate3d: function(offset) {
            return `translate3d(${offset}px, 0, 0)`;
        },

        /**
         * set slider translate3d
         * @param {number} offset default 0
         */
        sliderMove: function(offset = 0) {
            this.elSuffix.style.transform = this.translate3d(offset)
        },

        /**
         * set element.content translate3d
         * @param {number} offset default 0
         */
        translateContent: function(offset = 0) {
            this.elContent.style.transform = this.translate3d(offset)
        },

        /**
         * handle slider enter
         */
        sliderEnter: function() {
            this.elSuffix.style.transition = 'transform .25s'
            this.elSuffix.style.transform = this.translate3d(0)
            this.isEnter = true
            setTimeout(()=> {
                this.elSuffix.style.transition = 'none'
            }, 250)
        },

        /**
         * handle slider leave
         */
        sliderLeave: function() {
            this.elSuffix.style.transition = 'transform .25s'
            this.elSuffix.style.transform = this.translate3d(this.elSuffixWidth)
            this.isEnter = false
            setTimeout(()=> {
                this.elSuffix.style.transition = 'none'
            }, 250)
        },
        
        layout: function() {
            this.$nextTick(function() {
                this.elSuffix = this.$refs['cell'].$refs['suffix']
                this.elContent = this.$refs['cell'].$refs['content']
                
                if(this.elSuffix && this.elContent) {
                    this.elSuffixWidth = this.elSuffix.offsetWidth
                    this.elSuffix.style.transform = this.translate3d(this.elSuffixWidth)
                    this.elContent.style.transform = this.translate3d(0)
                }
            })
        },
    },
}
</script>
